/* ============================================================
   Swell Scenes — Free Print Follow Gate
   free-print-gate.js
   Mailchimp subscribe (via Cloudflare Worker) + 2-step follow gate logic
   ============================================================ */

(function () {
  'use strict';

  var cfg        = window.SSGateConfig || {};
  var WORKER_URL = cfg.workerUrl || '';
  var CODE       = cfg.code      || 'FREESCENE';

  var igClicked    = false;
  var redirectTimer = null;
  var scrollY       = 0;

  function $(id) { return document.getElementById(id); }

  /* ---- Scroll lock (works on iOS Safari) ---- */
  function lockScroll() {
    scrollY = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    window.scrollTo(0, scrollY);
  }

  /* ---- Focus trap ---- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function trapFocus(e) {
    var modal = $('ss-gate-modal');
    if (!modal) return;
    var focusable = modal.querySelectorAll(FOCUSABLE);
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  window.SSGate = {

    open: function () {
      var overlay = $('ss-gate-overlay');
      if (!overlay) return;
      overlay.classList.add('ss-open');
      lockScroll();
      var modal = $('ss-gate-modal');
      if (modal) modal.focus();
      document.addEventListener('keydown', trapFocus);
    },

    close: function () {
      var overlay = $('ss-gate-overlay');
      if (!overlay) return;
      overlay.classList.remove('ss-open');
      unlockScroll();
      document.removeEventListener('keydown', trapFocus);
      if (redirectTimer) {
        clearTimeout(redirectTimer);
        redirectTimer = null;
      }
      SSGate.reset();
    },

    markIGClicked: function () {
      igClicked = true;
      SSGate._revealConfirmRow();

      document.addEventListener('visibilitychange', function onReturn() {
        if (!document.hidden && igClicked) {
          SSGate._revealConfirmRow();
          document.removeEventListener('visibilitychange', onReturn);
        }
      });

      window.addEventListener('focus', function onFocus() {
        if (igClicked) {
          SSGate._revealConfirmRow();
          window.removeEventListener('focus', onFocus);
        }
      });
    },

    _revealConfirmRow: function () {
      var row = $('ss-confirm-row');
      if (row) row.classList.remove('ss-confirm-hidden');
    },

    toggleCheck: function () {
      var cb  = $('ss-ig-check');
      var btn = $('ss-next-btn');
      if (!cb || !btn) return;
      btn.classList.toggle('ss-ready', cb.checked);
      btn.disabled = !cb.checked;
      btn.setAttribute('aria-disabled', cb.checked ? 'false' : 'true');
    },

    goStep2: function () {
      var cb = $('ss-ig-check');
      if (!cb || !cb.checked) return;

      $('ss-step-1').classList.remove('ss-active');
      $('ss-step-2').classList.add('ss-active');

      var pd2 = $('ss-pd-2');
      if (pd2) pd2.classList.add('ss-done');

      var firstNameInput = $('ss-first-name');
      if (firstNameInput) {
        setTimeout(function () { firstNameInput.focus(); }, 100);
      }
    },

    goStep1: function () {
      $('ss-step-2').classList.remove('ss-active');
      $('ss-step-1').classList.add('ss-active');

      var pd2 = $('ss-pd-2');
      if (pd2) pd2.classList.remove('ss-done');
    },

    handleSubmit: function () {
      var emailInput = $('ss-email-input');
      var errorMsg   = $('ss-error-msg');
      var submitBtn  = $('ss-submit-btn');

      if (!emailInput || !submitBtn) return;

      /* Prevent double-tap */
      if (submitBtn.disabled) return;

      var email     = emailInput.value.trim();
      var firstName = ($('ss-first-name') || {}).value || '';
      var lastName  = ($('ss-last-name')  || {}).value || '';

      if (errorMsg) {
        errorMsg.textContent = '';
        errorMsg.classList.remove('ss-error-visible');
      }

      if (!firstName.trim()) {
        if (errorMsg) {
          errorMsg.textContent = 'Please enter your first name.';
          errorMsg.classList.add('ss-error-visible');
        }
        var fn = $('ss-first-name'); if (fn) fn.focus();
        return;
      }

      if (!email) {
        if (errorMsg) {
          errorMsg.textContent = 'Please enter your email address.';
          errorMsg.classList.add('ss-error-visible');
        }
        emailInput.focus();
        return;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        if (errorMsg) {
          errorMsg.textContent = 'Please enter a valid email address.';
          errorMsg.classList.add('ss-error-visible');
        }
        emailInput.focus();
        return;
      }

      submitBtn.disabled = true;
      submitBtn.classList.add('ss-loading');
      submitBtn.textContent = 'Signing you up\u2026';

      SSGate._subscribeMailchimp(email, firstName.trim(), lastName.trim(), function (success, err) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('ss-loading');
          submitBtn.textContent = 'Send me my free print code';
        }

        if (!success) {
          console.warn('Mailchimp subscribe failed:', err);
        }

        SSGate._revealCode();
      });
    },

    _subscribeMailchimp: function (email, firstName, lastName, callback) {
      if (!WORKER_URL || WORKER_URL === 'YOUR_CLOUDFLARE_WORKER_URL') {
        console.warn('SSGate: No Worker URL set. Skipping Mailchimp subscribe.');
        callback(true);
        return;
      }

      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email,
          first_name: firstName,
          last_name: lastName,
          tags: ['free-print-gate'],
          merge_fields: {
            SOURCE: 'free_print_gate',
            IG_OPT: 'yes'
          }
        })
      })
        .then(function (res) {
          if (res.ok) {
            callback(true);
          } else {
            res.json().then(function (data) {
              callback(false, data);
            }).catch(function () {
              callback(false, 'Non-JSON error response');
            });
          }
        })
        .catch(function (err) {
          callback(false, err);
        });
    },

    _revealCode: function () {
      var codeEl = $('ss-code-value');
      if (codeEl) codeEl.textContent = CODE;

      $('ss-step-2').classList.remove('ss-active');
      $('ss-step-3').classList.add('ss-active');

      var pd3 = $('ss-pd-3b');
      if (pd3) pd3.classList.add('ss-done');

      /* Gentle redirect — cancelled if user interacts (copy, shop, close) */
      redirectTimer = setTimeout(function () {
        window.location.href = '/pages/free-print-offer-thank-you';
      }, 12000);
    },

    copyCode: function () {
      var codeEl = $('ss-code-value');
      var copyBtn = $('ss-copy-btn');
      if (!codeEl) return;

      /* User interacted — cancel auto-redirect */
      if (redirectTimer) {
        clearTimeout(redirectTimer);
        redirectTimer = null;
      }

      var code = codeEl.textContent;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(function () {
          SSGate._flashCopied(copyBtn);
        }).catch(function () {
          SSGate._fallbackCopy(code, copyBtn);
        });
      } else {
        SSGate._fallbackCopy(code, copyBtn);
      }
    },

    _fallbackCopy: function (text, btn) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      SSGate._flashCopied(btn);
    },

    _flashCopied: function (btn) {
      if (!btn) return;
      var original = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(function () { btn.textContent = original; }, 2000);
    },

    reset: function () {
      var steps = document.querySelectorAll('.ss-gate-step');
      steps.forEach(function (s) { s.classList.remove('ss-active'); });
      var step1 = $('ss-step-1');
      if (step1) step1.classList.add('ss-active');

      var cb = $('ss-ig-check');
      if (cb) cb.checked = false;

      var row = $('ss-confirm-row');
      if (row) row.setAttribute('aria-checked', 'false');

      var nextBtn = $('ss-next-btn');
      if (nextBtn) {
        nextBtn.classList.remove('ss-ready');
        nextBtn.disabled = true;
        nextBtn.setAttribute('aria-disabled', 'true');
      }

      var fn = $('ss-first-name'); if (fn) fn.value = '';
      var ln = $('ss-last-name');  if (ln) ln.value = '';
      var emailInput = $('ss-email-input');
      if (emailInput) emailInput.value = '';

      var confirmRow = $('ss-confirm-row');
      if (confirmRow) confirmRow.classList.add('ss-confirm-hidden');

      var errorMsg = $('ss-error-msg');
      if (errorMsg) {
        errorMsg.textContent = '';
        errorMsg.classList.remove('ss-error-visible');
      }

      var pd2 = $('ss-pd-2');
      if (pd2) pd2.classList.remove('ss-done');
      var pd3 = $('ss-pd-3b');
      if (pd3) pd3.classList.remove('ss-done');

      if (redirectTimer) {
        clearTimeout(redirectTimer);
        redirectTimer = null;
      }

      igClicked = false;
    }

  };

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = $('ss-gate-overlay');
    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) SSGate.close();
      });
    }

    var EXTERNAL_TRIGGERS = [
      '[id$="__image_with_text_zN3waD"] .button',
      '[class*="__rich_text_U3MmNc-padding"] .button'
    ];

    EXTERNAL_TRIGGERS.forEach(function (selector) {
      var btns = document.querySelectorAll(selector);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          SSGate.open();
        });
      });
    });
  });

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.keyCode === 27)) {
      var overlay = $('ss-gate-overlay');
      if (overlay && overlay.classList.contains('ss-open')) {
        SSGate.close();
      }
    }
  });

})();
